import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import TableActionButton from "../Reusable/TableActionButton";
import DataTable from "../Reusable/Datatable";
import APIS from "../../constant/Endpoint";
import { classNames } from "../../utils/classNames";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { usePDFPrintHook } from "@careinfo/layout";
import { AccessControl } from "@careinfo/permission-required";

export default () => {
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const [searchParams, setSearchParms] = useSearchParams();
  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const navigate = useNavigate();
  const handleRowClick = (row:any) =>{
    navigate(`edit/${row.original.id}`);
  }

  const handleIndividualSelect = (value: string) => {
    const clonedParams = new URLSearchParams(searchParams);
    const selectedItems = clonedParams.get("selectedItems")?.split(",");
    if (!selectedItems || !selectedItems === undefined) {
      clonedParams.set("selectedItems", value);
      setSearchParms(clonedParams);
      return;
    }
    const itemIndex = selectedItems?.findIndex((item) => item === value);
    if (itemIndex > -1) {
      selectedItems.splice(itemIndex, 1);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      if (newSelectedItems.length) {
        clonedParams.set("selectedItems", newSelectedItems);
      } else {
        clonedParams.delete("selectedItems");
      }
      clonedParams.set("selectAllItems", "0");
    } else {
      selectedItems?.push(value);
      const newSelectedItems = selectedItems
        ?.map((item) => item)
        .join(",")
        .toString();
      clonedParams.set("selectedItems", newSelectedItems);
    }
    setSearchParms(clonedParams);
  };

  const isSelected = (value: string) => {
    const selectedItems = searchParams.get("selectedItems")?.split(",");
    if (!selectedItems) {
      return false;
    }
    return selectedItems.includes(value);
  };

  const handleSelectAll = (table: any) => {
    const {
      options: { data: tableData },
    } = table;
    const clonedParams = new URLSearchParams(searchParams);
    const isSelected = clonedParams.get("selectAllItems");
    if (isSelected === "1") {
      clonedParams.set("selectAllItems", "0");
      clonedParams.delete("selectedItems");
    } else {
      const selectedItems = tableData
        ?.map((item: any) => item.id)
        .join(",")
        .toString();
      clonedParams.set("selectAllItems", "1");
      clonedParams.set("selectedItems", selectedItems);
    }
    setSearchParms(clonedParams);
  };
  const columns: ColumnDef<any, any>[] = [
    {
      id: "select",
      header: ({ table }: any) => {
        return (
          <input
            type="checkbox"
            checked={checkedAllItems}
            onChange={() => handleSelectAll(table)}
            className={tw`cursor-pointer`}
          />
        );
      },
      cell: ({ row }: any) => (
        <input
          type="checkbox"
          checked={isSelected(row?.original?.id)}
          onChange={() => {
            handleIndividualSelect(row?.original?.id);
          }}
          className={tw`cursor-pointer`}
          onClick={(e)=>e.stopPropagation()}
        />
      ),
    },
    {
      accessorKey: "voucher_date",
      header: "Date",
      cell: ({ row, getValue }: any) => (
        <p className={tw`whitespace-nowrap`}>{getValue()}</p>
      ),
    },
    {
      accessorKey: "miti",
      header: "Miti",
      cell: ({ row, getValue }: any) => (
        <p className={tw`whitespace-nowrap`}>{getValue()}</p>
      ),
    },
    {
      accessorKey: "seq_no",
      header: "Voucher Number",
    },
    {
      accessorKey: "type",
      header: "Entry Type",
    },
    {
      accessorKey: "reference_date",
      header: "Ref Date",
    },
    {
      accessorKey: "reference_number",
      header: "Ref Number",
    },
    {
      accessorKey: "narration",
      header: "Narration",
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row, getValue }) => (
        <p
          className={classNames(
            getValue() === "Draft" ? tw`bg-yellow-400` : tw`bg-[#32CD32]`,
            tw`px-2 py-1 text-center rounded-md`
          )}
        >
          {getValue()}
        </p>
      ),
    },
    // {
    //   accessorKey: "id",
    //   header: "Action",
    //   cell: ({ row, getValue }: any) => {
    //     return (
    //       <div className={tw`flex gap-x-4 items-center`}>
    //         <AccessControl allowedPermissions={["can_edit_credit_note"]}>
    //           <TableActionButton editPath={`edit/${getValue()}`} />
    //         </AccessControl>
    //         {/* <button type="button" className={tw`focus:outline-none w-6 h-6`}>
    //         <DeleteIcon color={"var(--primary)"} />
    //       </button> */}
    //       </div>
    //     );
    //   },
    // },
  ];

  const handlePrint = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one first...");
      return;
    }
    const url = APIS.BILL_PRINT;
    let formData = {
      ids: selectedOrder,
      type: "Credit Note",
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <DataTable
        columns={columns}
        queryKey="credit-note"
        url={APIS.JOURNAL_ENTRY}
        onRowClick={handleRowClick}
        tableName="credit-note"
        addNew={{
          path: "/accounting/credit-note/create",
          label: "Make Entry",
        }}
        params={{
          type: "Credit Note",
        }}
        actionTools={
          <>
            <div className={tw`flex  w-full items-center`}>
              <AccessControl allowedPermissions={["can_print_credit_note"]}>
                <button
                  type="button"
                  onClick={() => handlePrint()}
                  disabled={isPrintLoading || false}
                  className={tw`px-6 rounded-md py-2 bg-primary text-white focus:outline-none`}
                >
                  Print
                </button>
              </AccessControl>
            </div>
          </>
        }
      />
    </div>
  );
};
